import { create } from 'zustand';

interface DocumentTypesStore {
  search: string;
  debounced: string;
  page: number;
  addOpen: boolean;
  editTarget: unknown | null;
  deleteConfirm: unknown | null;
  deleteError: string | null;
  setSearch: (q: string) => void;
  setDebounced: (q: string) => void;
  setPage: (p: number) => void;
  setAddOpen: (open: boolean) => void;
  setEditTarget: (t: unknown | null) => void;
  setDeleteConfirm: (t: unknown | null) => void;
  setDeleteError: (e: string | null) => void;
}

export const useDocumentTypesStore = create<DocumentTypesStore>((set) => ({
  search: '',
  debounced: '',
  page: 1,
  addOpen: false,
  editTarget: null,
  deleteConfirm: null,
  deleteError: null,
  setSearch: (q) => set({ search: q }),
  setDebounced: (q) => set({ debounced: q }),
  setPage: (p) => set({ page: p }),
  setAddOpen: (open) => set({ addOpen: open }),
  setEditTarget: (t) => set({ editTarget: t }),
  setDeleteConfirm: (t) => set({ deleteConfirm: t }),
  setDeleteError: (e) => set({ deleteError: e }),
}));
